(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('AiAssistantHistoryController', AiAssistantHistoryController);

    AiAssistantHistoryController.$inject = ['AiAssistantHistory', 'AlertService'];

    function AiAssistantHistoryController(AiAssistantHistory, AlertService) {
        var vm = this;

        vm.loadingOverview = false;
        vm.loadingDetail = false;
        vm.selectedConversation = null;
        vm.detail = null;
        vm.overview = {
            totalConversations: 0,
            totalTokens: 0,
            conversations: []
        };

        vm.loadOverview = loadOverview;
        vm.selectConversation = selectConversation;
        vm.isConversationSelected = isConversationSelected;
        vm.getActionBadgeClass = getActionBadgeClass;
        vm.hasVisibleConversationContent = hasVisibleConversationContent;

        loadOverview();

        function loadOverview() {
            vm.loadingOverview = true;
            AiAssistantHistory.getOverview().then(function(response) {
                vm.overview = response.data || vm.overview;
                if (vm.selectedConversation) {
                    syncSelectedConversation();
                }
            }).catch(function(error) {
                AlertService.error(resolveErrorMessage(error, 'Impossible de charger votre historique assistant IA.'));
            }).finally(function() {
                vm.loadingOverview = false;
            });
        }

        function selectConversation(conversation) {
            if (!conversation || !conversation.conversationId) {
                return;
            }
            vm.selectedConversation = conversation;
            vm.loadingDetail = true;
            vm.detail = null;
            AiAssistantHistory.getDetail(conversation.conversationId).then(function(response) {
                vm.detail = response.data || null;
            }).catch(function(error) {
                AlertService.error(resolveErrorMessage(error, 'Impossible de charger le detail de cette conversation.'));
            }).finally(function() {
                vm.loadingDetail = false;
            });
        }

        function syncSelectedConversation() {
            var updatedConversation = null;
            angular.forEach(vm.overview.conversations || [], function(conversation) {
                if (!updatedConversation && vm.selectedConversation
                    && conversation.conversationId === vm.selectedConversation.conversationId) {
                    updatedConversation = conversation;
                }
            });
            if (updatedConversation) {
                vm.selectedConversation = updatedConversation;
            }
        }

        function isConversationSelected(conversation) {
            return vm.selectedConversation && conversation && vm.selectedConversation.conversationId === conversation.conversationId;
        }

        function getActionBadgeClass(hasExecutedActions) {
            return hasExecutedActions ? 'label label-warning' : 'label label-default';
        }

        function hasVisibleConversationContent(event) {
            return !!(event
                && (event.requestTotalTokens
                || event.sentMessage
                || event.receivedMessage
                || (event.clarificationQuestions && event.clarificationQuestions.length)
                || (event.actionSummaries && event.actionSummaries.length)
                || event.hasAction));
        }

        function resolveErrorMessage(error, fallbackMessage) {
            return (error && error.headers && error.headers('X-wamasysApp-detail')) || fallbackMessage;
        }
    }
})();
